<div class="login-container">
    <h1 class="login-header">santosh.app</h1>
    <button mat-raised-button color = "primary"
    (click) = "login()">Login With Google</button>
</div>